import { ImageUpload } from "components/imageUpload";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import { useTranslation } from "react-i18next";

import styles from "./CmsFooterAppsSlot.module.scss";
import { ReactComponent as DeleteIcon } from "assets/icons/bin-icon.svg";
import cn from "clsx";
import { useRef } from "react";
import { ImageUploadRef } from "components/imageUpload/ImageUpload";

type Props = {
  id: number | string;
  name: string;
  link: string;
  image: string | File;
  onChangeLink: (e: string) => void;
  onAddImage?: (e: File) => void;
  onClearSlot?: () => void;
  isDeleting?: boolean;
  isModified?: boolean;
  isActive?: boolean;
  readOnly?: boolean;
};

export const CmsFooterAppsSlot: React.FC<Props> = ({
  id,
  name,
  link,
  image,
  onChangeLink,
  onAddImage,
  onClearSlot,
  isDeleting = false,
  isModified,
  isActive,
  readOnly
}) => {
  const { t } = useTranslation();
  const imageRef = useRef<ImageUploadRef | null>(null);

  const handleClearSlot = () => {
    imageRef.current?.clearImage();
    onClearSlot?.();
  };

  return (
    <div
      className={cn(
        styles.cmsAppsCard,
        isDeleting && styles.cmsAppsCardLoading,
      )}
    >
      <div className={styles.cmsAppsCardImage}>
        <ImageUpload
          image={image}
          className={styles.cmsAppsCardImageUpload}
          onAddImage={onAddImage}
          ref={imageRef}
          isActive={isActive}
          disabled={readOnly}
        />
      </div>
      <div className={styles.cmsAppsCardInfo}>
        <div className={styles.cmsAppsCardAlt}>
          <InnerInput
            value={name}
            placeholder={t("enterPlatform")}
            label={t("platform")}
            type="text"
            id={`app-platform-${id}`}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className={styles.cmsAppsCardLink}>
          <InnerInput
            value={link}
            placeholder={t("link")}
            label={t("link")}
            type="text"
            id={`app-link-${id}`}
            onChange={onChangeLink}
            disabled={readOnly}
          />
        </div>
      </div>
      {isModified && !readOnly && (
        <div>
          <button
            className={styles.cmsAppsCardDelete}
            onClick={handleClearSlot}
          >
            <DeleteIcon />
          </button>
        </div>
      )}
    </div>
  );
};
